import { atom } from "recoil";

export default atom({
  key: "error-message",
  default: {
    message: "",
  },
});
